import { InteractiveTableColumnConfiguration } from '@dreryk/react-components';

import { interactiveTableKeys } from '../../../translations';

import { BodySideCell } from './cells/BodySideCell';
import { DiagnosesWithBodySideTableBean } from './DiagnosesWithBodySideInteractiveTable.types';

export const createBodySideColumn = (): InteractiveTableColumnConfiguration<DiagnosesWithBodySideTableBean> => {
   return {
      name: 'bodySide',
      label: interactiveTableKeys.headers.bodySide,
      width: '198px',

      renderer: ({ bean, index }) => {
         return <BodySideCell testId={'bodySide'} name={'bodySide'} index={index} defaultValue={bean.bodySide} />;
      },
   };
};
